angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerImportHistoryDetailsController', ['$scope', 
        function ($scope) {
            var blade = $scope.blade;
            blade.headIcon = 'fas fa-file-import';
            blade.isLoading = false;
        }
    ]);
